module.exports = __webpack_public_path__ + "static/media/metamask.61091573.png";